import { useMutation, useQueryClient } from '@tanstack/react-query'
import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Trans, useTranslation } from 'react-i18next'
import { DisasterService } from '../../services/disasterRiskManagement/DisasterRiskManagementService'

type ProxyStatusModalProps = {
  setIsProxyModelOpen: React.Dispatch<React.SetStateAction<boolean>>
  currentTenantId: string
  disasterId: number
  userId?: string
  proxyStatus?: string | null
}

export function ProxyStatusModal({
  setIsProxyModelOpen,
  currentTenantId,
  disasterId,
  proxyStatus,
  userId,
}: ProxyStatusModalProps) {
  return (
    <Modal
      setIsProxyModelOpen={setIsProxyModelOpen}
      currentTenantId={currentTenantId}
      disasterId={disasterId}
      proxyStatus={proxyStatus}
      userId={userId}
    />
  )
}

const Modal: React.FC<ProxyStatusModalProps> = ({
  setIsProxyModelOpen,
  currentTenantId,
  disasterId,
  proxyStatus,
  userId,
}) => {
  const { t } = useTranslation()
  const [statusValue, setStatusValue] = useState(proxyStatus || '')
  const queryClient = useQueryClient()
  // Sync with props if proxyStatus changes
  useEffect(() => {
    setStatusValue(proxyStatus || '')
  }, [proxyStatus])

  const updateUserStatusMutation = useMutation({
    mutationFn: async () => {
      if (!userId || !disasterId)
        throw new Error('Missing userId or disasterId')
      return DisasterService.updateUserStatus(
        disasterId,
        currentTenantId,
        userId,
        undefined,
        statusValue
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user-safety-list', disasterId],
      })
      setIsProxyModelOpen(false)
    },
    onError: (error) => {
      console.error('Failed to update status:', error)
    },
  })

  const handleSave = () => {
    setIsProxyModelOpen(false)
    if (proxyStatus?.trim() !== statusValue.trim()) {
      updateUserStatusMutation.mutate()
    }
  }

  return createPortal(
    <div className="modal-area without-overlay-bg-modal modal-tsunami-earthquake uk-box-shadow-xlarge">
      <div className="modal-edit color-white bg-grey-80">
        <button
          className="uk-position-top-right uk-margin-small-top close-button"
          onClick={() => setIsProxyModelOpen(false)}
        >
          <Trans>BUTTONS.CLOSE_BUTTON</Trans>X
        </button>

        <p className="uk-margin-remove mt-30">
          代理入力の内容を確認し安否ステータスを変更してください。
        </p>

        <textarea
          className="uk-textarea uk-margin-small"
          value={statusValue}
          onChange={(e) => setStatusValue(e.target.value)}
          maxLength={30}
          draggable={false}
          style={{ resize: 'none' }}
        />

        <div className="uk-text-right">
          <button className="save-button" onClick={handleSave}>
            <Trans>BUTTONS.SAVE</Trans>
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
